
import {Scene} from "../Scene";
import {ISceneNode, SceneNodeState} from "../ISceneNode";
import {NodePlacer} from "../../controller/NodePlacer";
import {Raycaster, Mesh, Box3} from "three";
import {Building, WallSide} from "building/Building";

export class SceneAddonType
{
	static WALL = "wall";
	static ROOF = "roof";
}

export type WallAddonPosition = {
	wall: WallSide;
	horizontal: number;
	vertical: number;
	x: number;
	y: number;
	z: number
};

export interface ISceneAddon extends ISceneNode
{
	itemId: string; // used for serialization for project settings
	type: string;
	state: SceneNodeState;
	added: boolean;
	//parentId:string;
	hasValidPlace: boolean;

	width?: number;
	height?: number;

	// used for reseting position
	setPosition(value: any): boolean; /** returns the validity of the position */
	getPosition(): WallAddonPosition | any;

	getBoundingBox(): Mesh;
	getBBox(): Box3;

	checkPlacing(rayCaster: Raycaster, scene: Scene, nodePlacer: NodePlacer): boolean;
	updatePosition(): boolean;

	show(): void;
	hide(): void;

	parentId: string;
}
